import React from 'react';

import { RegularButton as Button } from 'fronton-react';
import { PencilSimpleIcon } from '@fronton/icons-react';

export const EditParamsButtonComponent: React.FC = () => (
  <Button variant="pseudo" size="s" label="Изменить параметры" type="submit" iconOnly>
    <PencilSimpleIcon type="outline" size="l" color="text-primary" />
  </Button>
);
